import { OpportunitiesListingComponent } from './opportunities-listing/opportunities-listing.component';
import { DeletedListingComponent } from './deleted-listing/deleted-listing.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'meetings',
    component: AuthenticatedComponent,
    children: [
      {
        path: 'deleted',
        canActivate: [AuthGuard],
        component: DeletedListingComponent,
      },
      {
        path: 'opportunities',
        canActivate: [AuthGuard],
        component: OpportunitiesListingComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeetingsRoutingModule {}
